<template>
  <v-container fluid pa-0 ma-0>
    <v-layout row wrap class="ma-0">

      <v-toolbar class="pa-0 ma-0 toolbar-padding"
                 color="white" flat dense fixed app>
        <v-btn small flat icon @click="$router.go(-1)">
          <v-icon size="24px">$vuetify.icons.navArrowLeft</v-icon>
        </v-btn>
        <h3 class="display-2" style="margin-bottom: 2px">찜 목록</h3>
      </v-toolbar>

      <v-flex xs12>
        <v-card tile class="pa-0 card-shadow">
          <v-card-title class="px-3" style="padding-top: 12px; padding-bottom: 12px;">
            <span style="font-weight: 700; font-size: 16px; letter-spacing: -0.3px; color: black;">
              찜한 스토리 <span style="color: #ec2f54;">{{ wish_cnt }}</span>개
            </span>
          </v-card-title>
        </v-card>
      </v-flex>

      <v-flex xs12 v-if="wishes.length">
        <v-card tile class="pt-0 pb-4 mt-2 overflow-x-hidden card-shadow" v-if="wishes.length">
          <v-card-text class="ma-0 pt-4 pl-0 pr-0 pb-0">
            <v-container fluid grid-list-md class="py-0">
              <v-layout row wrap>
                <v-flex xs6 v-for="(product, index) of wishes" :key="index">
                  <ProductCard :idx="product.idx"
                               :title="product.title"
                               :subtitle="product.subtitle"
                               :publishedAt="product.published_at"
                               :status="product.status"
                               :thumbnail="product.thumbnail"
                               :bookmarks="product.bookmarks"
                               :subtitle_color="product.subtitle_color"
                               @bookmark="bookmarkProduct(product.idx)" />
                </v-flex>

              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex v-else>
        <div style="color: #9b9b9b;" class="my-5">
          <div class="mb-3">찜한 스토리가 없습니다.</div>
          <div>
            마음에 드는 스토리가 있다면<br>
            하트<v-icon size="20px">$vuetify.icons.heartOutlined</v-icon>를 눌러 찜해보세요.
          </div>
        </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex';
  import ProductCard from '@/components/ProductCard';

  export default {
    name: 'Wishes',
    components: { ProductCard },
    computed: {
      ...mapGetters('user', [ 'idx', 'wishes', 'wish_cnt' ]),
    },
    data () {
      return {
        time: parseInt(new Date().getTime() / 1000),
        scrollY: 0,
        page: 1,
        bottom: true,
      };
    },
    created () {
      this.selectWishes({ second: this.time, userIdx: this.idx, page: this.page }).then(() => {
        this.page++;
      });
      window.addEventListener('scroll', this.getScrollY);
    },
    destroyed () {
      window.removeEventListener('scroll', this.getScrollY);
    },
    watch: {
      bottom (bottom, oldBottom) {
        if (bottom && !oldBottom) {
          this.selectWishes({ second: this.time, userIdx: this.idx, page: this.page }).then(() => {
            this.page++;
          });
        }
      },
    },
    methods: {
      ...mapActions('product', [ 'toggleBookmark' ]),
      ...mapActions('user', [ 'selectWishes' ]),
      ...mapMutations('user', { mutationToggleBookmark: 'TOGGLE_BOOKMARK_PRODUCT' }),
      ...mapMutations('home', { mutationToggleStoreBookmark: 'TOGGLE_STORE_BOOKMARK' }),
      getScrollY () {
        this.scrollY = window.scrollY;
        this.bottomVisible();
      },
      bookmarkProduct (idx) {
        this.toggleBookmark(idx).then(response => {
          this.mutationToggleBookmark({ idx, flag: response.data });
          this.mutationToggleStoreBookmark({ idx, flag: response.data });
        }).catch(err => {
          console.error(err);
        });
      },
      bottomVisible () {
        const scrollY = window.scrollY;
        const visible = document.documentElement.clientHeight;
        const pageHeight = document.documentElement.scrollHeight;
        const bottomOfPage = visible + scrollY >= pageHeight - 200;
        this.bottom = bottomOfPage || pageHeight < visible;
      },
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.toolbar-shadow .v-toolbar__content {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  /deep/.toolbar-padding .v-toolbar__content {
    padding: 0 10px 0 16px;
  }

  // custom grid-list-md gutter settings
  /deep/.container.grid-list-md .layout:only-child {
    margin: -5px;
  }
  /deep/.container.grid-list-md .layout .flex {
    padding: 5px;
  }

  /deep/.card-shadow {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }
</style>
